module.exports = __webpack_public_path__ + "img/invite-1861059a.6f39d3a8.png";